/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brief_New_Cuckoo_SeekInputs */

const fr_brief_new_cuckoo_seek = /** @type {(inputs: Brief_New_Cuckoo_SeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editer WOD`)
};

/**

* @param {Brief_New_Cuckoo_SeekInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const brief_new_cuckoo_seek = /** @type {((inputs?: Brief_New_Cuckoo_SeekInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brief_New_Cuckoo_SeekInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_brief_new_cuckoo_seek(inputs)
});